import { create } from 'zustand';
import site from '../../data/master.json';

export const useSiteStore = create((set) => ({
  hasVideo: !!site.hero.videoSrc,

  sections: {
    hero: true,
    menu: !!site.menu,
    experience: !!site.experience?.tiles?.length,
    testimonials: !!site.testimonials?.reviews?.length,
    gallery: !!site.gallery?.length,
    team: !!site.team?.image,
    origin: !!site.origin?.image,
  },

  navLinks: [
    { label: 'Home', path: '/', section: 'hero' },
    { label: 'Shows', path: '/shows', section: null },
    { label: 'Tour Map', path: '/map', section: null },
    { label: 'Private Events', path: '/booking', section: null },
  ],

  toastExpanded: true,
  setToastExpanded: (val) => set({ toastExpanded: val }),

  toastAnimated: false,
  setToastAnimated: () => set({ toastAnimated: true }),
}));